"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopBarLink = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _useResizeObserver = require("design_system/hooks/useResizeObserver");
var _Layout = require("design_system/Layout");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const THEME = {
  text: "text-white",
  position: "flex items-center whitespace-nowrap",
  hover: "hover:underline hover:cursor-pointer",
  focus: "focus:outline-none focus:underline",
  icon: "mr-8 s768:mr-4"
};
const TopBarLink = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    className,
    children,
    leadingIcon,
    ...props
  } = _ref;
  const [width] = (0, _useResizeObserver.useResizeObserver)();
  return /*#__PURE__*/_react.default.createElement(_Layout.Box, _extends({
    as: "a",
    ref: ref,
    text: THEME.text,
    hover: THEME.hover,
    focus: THEME.focus,
    className: (0, _classnames.default)(THEME.position, className),
    "aria-haspopup": "false",
    tabIndex: 0,
    role: "menuitem"
  }, props), /*#__PURE__*/(0, _react.isValidElement)(leadingIcon) ? /*#__PURE__*/(0, _react.cloneElement)(leadingIcon, {
    className: (0, _classnames.default)(THEME.icon, leadingIcon.props.className),
    "aria-hidden": true,
    size: width > _useResizeObserver.BREAKPOINTS.s768 ? 24 : 20
  }) : null, children);
});
exports.TopBarLink = TopBarLink;
TopBarLink.displayName = "TopBar.Link";